import { render } from "./OrderSLA.vue?vue&type=template&id=8ff4208e"
import script from "./OrderSLA.vue?vue&type=script&lang=js"
export * from "./OrderSLA.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/abg/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__